/* import __COLOCATED_TEMPLATE__ from './signup-fieldset.hbs'; */
import Component from '@ember/component';

/** @class */
const SignupFieldset = Component.extend({
  /** @inheritDoc */
  tagName: 'section',

  /** @inheritDoc */
  classNames: ['signup-form__section'],

  /** @type {string} */
  title: '',

  /** @type {string} */
  subtitle: '',
});

export default SignupFieldset;
